export type SmartyAddress = {
  primaryNumber?: string;
  streetPredirection?: string;
  streetName?: string;
  streetSuffix?: string;
  streetPostdirection?: string;
  secondaryDesignator?: string;
  secondaryNumber?: string;
  cityName?: string;
  state?: string;
  zipCode?: string;
  street1?: string;
  street2?: string | null;
  country?: string;
  zipcode?: string;
  city?: string;
};

export const countries = ['United States', 'Canada', 'Other'];

export interface Values {
  id?: string;
  name: string;
  street1: string;
  street2: string;
  countryCode: string;
  city: string;
  state?: string;
  province?: string;
  zipcode: string;
  phoneNumber: string;
  emailAddress: string;
  country: string;
  internationalVerification: boolean;
  defaultIndicator: boolean;
}

export type UserShippingAddressResponse = {
  id?: string;
  name: string;
  street1: string;
  street2?: string;
  street3?: string;
  country: string;
  country_code: string;
  city: string;
  state?: string;
  province?: string;
  zipcode: string;
  phone_number: string;
  phone_ext?: string;
  email_address: string;
  validated?: boolean;
  validation_exempt?: boolean;
};

export type MappedShippingAddress = {
  id?: string;
  name: string;
  street1: string;
  street2?: string;
  street3?: string;
  country: string;
  countryCode: string;
  city: string;
  state?: string;
  province?: string;
  zipcode: string;
  phoneNumber: string;
  phoneExt?: string;
  emailAddress: string;
  validated: boolean;
  validationExempt: boolean;
  organizationId?: string;
  internationalVerification?: boolean;
  defaultIndicator: boolean;
};

export type UserShippingAddressPayload = {
  address: UserShippingAddressResponse;
  index?: number | null;
  set_default_address?: boolean;
};
export interface EditShippingAddressFormProps {
  onSave: (values: MappedShippingAddress) => Promise<void>;
  onCancelClick: () => void;
  onRemove?: () => void;
  requestFailed: boolean;
  shippingAddress?: MappedShippingAddress;
  showMode: 'Edit' | 'New';
  index?: number;
  entityType: entityTypeEnum;
}

export enum userRoleEnum {
  admin = 'admin',
  contributor = 'contributor',
}

export enum entityTypeEnum {
  user = 'user',
  team = 'team',
}
